import { usePractice } from "../usePractice";
import { getBrand } from "../utils/brand";
import { Helmet } from "react-helmet-async";

function PrivacyPolicy() {
  const { practice } = usePractice();
  const brand = getBrand(practice?.fields?.brand);

  return (
    <div className="container">
      <Helmet>
        <title>{brand.name} - Privacy Policy</title>
      </Helmet>
      <h2 className="mb-2 text-center">Privacy Policy</h2>

      <p>
        <strong>Effective Date:</strong> December 1, 2025
      </p>

      <p>
        At Evvi Aftercare & Resting Waters, we respect your privacy and are
        committed to protecting your personal information.
      </p>

      <p>
        <strong>Information We Collect</strong>
      </p>

      <p>We collect the following information from our customers:</p>
      <ul>
        <li>Name</li>
        <li>Phone number</li>
        <li>Email address</li>
        <li>Address</li>
        <li>Pet information</li>
      </ul>

      <p>
        <strong>How We Use Your Information</strong>
      </p>

      <p>We use your information solely to:</p>
      <ul>
        <li>Provide our aftercare services for your pet</li>
        <li>
          Communicate with you about appointments, services, and account updates
        </li>
        <li>Process payments and maintain records</li>
      </ul>

      <p>
        <strong>SMS Communication</strong>
      </p>

      <p>
        Evvi Aftercare uses customer phone numbers to provide service updates
        and account notifications via text message. Message frequency varies
        based on your service needs. Standard message and data rates may apply.
        You may opt out at any time by replying <strong>STOP</strong> to any SMS
        message from us.
      </p>

      <p>
        <strong>We Don't Share or Sell Your Information</strong>
      </p>

      <p>
        <strong>
          Evvi Aftercare does not share, sell, or give your personal information
          to third parties.
        </strong>{" "}
        Your information remains private and is used only to serve you and your
        pet.
      </p>

      <p>
        <strong>Mobile Information</strong>
      </p>

      <p>
        No mobile information will be shared with third parties or affiliates
        for marketing or promotional purposes. We may share information with
        subcontractors who provide support services, such as customer service,
        but only as necessary to deliver our services to you.
      </p>

      <p>
        <strong>Text Messaging Opt-In Data</strong>
      </p>

      <p>
        Text messaging originator opt-in data and consent will not be shared
        with any third parties under any circumstances.
      </p>

      <p>
        <strong>Changes To This Privacy Policy</strong>
      </p>

      <p>
        We may periodically update this policy. We will notify you about any
        significant changes in the way we handle your personal information by
        sending a notice to the email address specified in your account, or by
        placing a prominent notice on our site.
      </p>

      <p>
        <strong>Contact Us</strong>
      </p>

      <p>
        If you have questions about this Privacy Policy, please contact us at{" "}
        <a href="mailto:support@evviaftercare.com">support@evviaftercare.com</a>
        .
      </p>
    </div>
  );
}

export default PrivacyPolicy;
